import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { classNames } from "primereact/utils";
import { Tree } from "primereact/tree";
import { classeursService,actifsService  } from "../../services";
import { CustomDialog, FormEditCorrespondanceClasseur, showToast } from "..";
import { NODES_CLASSEUR_EDIT } from "../../utils/NodesClasseur";
import { Classeur,Actif } from "../../interfaces";

import { TabMenu } from "primereact/tabmenu";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "../../utils/UserProvider";
interface ModalEditClasseurProps {
  modalIsOpenEdit: boolean;
  closeModalEdit: () => void;
  selectedClasseur: Classeur;
  setLoading: (newvalue: boolean) => void;
}
const ModalEditClasseur = ({
  modalIsOpenEdit,
  closeModalEdit,
  selectedClasseur,
  setLoading,
}: ModalEditClasseurProps) => {
  const queryClient = useQueryClient();
  const [selectedKey, setSelectedKey] = useState(null);
  const [selectedNode, setSelectedNode] = useState<string | null>(null);
  const [selectedNodeFidji, setSelectedNodeFidji] = useState<string | null>(
    null
  );
  const { user, client } = useAuth();

  const { data:actifs } = useQuery<Actif[]>({
    queryKey: [
      "actifs",
      user,
      client
    ],
    queryFn: async () => {
        const response = await actifsService.getactifs(
        client.id,
        user.id
        );
        return response;
      
    },});


  const [activeIndex, setActiveIndex] = useState<number>(0);

  const items = [
    { label: "Modifier informations", icon: "pi pi-info-circle" },
    { label: "Modifier correspondance", icon: "pi pi-sitemap" },
  ];

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm();

  const nodeTemplate = (node) => {
    let label = <b>{node.label}</b>;

    if (node.key === selectedKey) {
      label = (
        <span className="space-x-2">
          {node.label}{" "}
          <i className="pi pi-check text-lg font-bold text-green-500"></i>
        </span>
      );
    }

    return (
      <span className="space-x-2">
        <i className="pi pi-folder"></i>
        {label}
      </span>
    );
  };

  const togglerTemplate = (node, options) => {
    if (!node) {
      return;
    }

    const expanded = options.expanded;
    const iconClassName = classNames("p-tree-toggler-icon pi pi-fw", {
      "pi-caret-right": !expanded,
      "pi-caret-down": expanded,
    });

    return (
      <button
        type="button"
        className="p-tree-toggler p-link"
        tabIndex={-1}
        onClick={options.onClick}
      >
        <span className={iconClassName} aria-hidden="true"></span>
      </button>
    );
  };

  const findNodeByNodeKey = (nodes, targetKey) => {
    for (const node of nodes) {
      if (node.key === targetKey) {
        return node;
      } else if (node.children) {
        const foundNode = findNodeByNodeKey(node.children, targetKey);
        if (foundNode) {
          return foundNode;
        }
      }
    }
    return null;
  };

  const onSelectionChange = (e) => {
    const selected = e.value;
    const foundNode = findNodeByNodeKey(NODES_CLASSEUR_EDIT, selected);
    if (selected) {
      if ((Number(selected) >= 1 && Number(selected) <= 12) || (foundNode.children)) {
        setSelectedKey(null);
      } else {
        setSelectedKey(selected);
        if (foundNode) {
          setSelectedNode(foundNode.label);
            
         
          if (foundNode.key === "1-10") setSelectedNodeFidji("01.02. Titres & actes");
          else if (foundNode.key === "1-11") setSelectedNodeFidji("4.01. Permis");
          else if (foundNode.key === "1-12") setSelectedNodeFidji("05.01. Plans");
          else if (foundNode.key === "1-13") setSelectedNodeFidji("01.02. Titres & actes"); // vérifier
          else if (foundNode.key === "1-14") setSelectedNodeFidji("05.03. Copropriété & gouvernance de voisinage");
          else if (foundNode.key === "1-15") setSelectedNodeFidji("03.01. Médias");
  
          else if (foundNode.key === "2-20") setSelectedNodeFidji("05.05. Documents d’urbanisme"); // vérifier
          else if (foundNode.key === "2-21") setSelectedNodeFidji("4.01. Permis");
          else if (foundNode.key === "2-22") setSelectedNodeFidji("4.01. Permis");
  
          else if (foundNode.key === "3-30") setSelectedNodeFidji("05.03. Copropriété & gouvernance de voisinage");
          else if (foundNode.key === "3-31") setSelectedNodeFidji("05.03. Copropriété & gouvernance de voisinage");
          else if (foundNode.key === "3-32") setSelectedNodeFidji("05.03. Copropriété & gouvernance de voisinage"); //vérifier
          else if (foundNode.key === "3-33") setSelectedNodeFidji("4.05. Réception de travaux");   
          else if (foundNode.key === "3-34") setSelectedNodeFidji("05.03. Copropriété & gouvernance de voisinage");
  
          else if (foundNode.key === "4-40") setSelectedNodeFidji("06.02. Locataire");
          else if (foundNode.key === "4-41") setSelectedNodeFidji("06.01. Situation locative");
          else if (foundNode.key === "4-42") setSelectedNodeFidji("06.02. Locataire");
  
          else if (foundNode.key === "5-50") setSelectedNodeFidji("02.04. Fiscalité");
  
          else if (foundNode.key === "6-60") setSelectedNodeFidji("02.03. Comptabilité");
  
          else if (foundNode.key === "7-70") setSelectedNodeFidji("02.05. Contrats tiers");
          else if (foundNode.key === "7-71") setSelectedNodeFidji("06.03. Exploitation");
  
          else if (foundNode.key === "8-80") setSelectedNodeFidji("4.03. Contrats & assurances");//vérifier
          else if (foundNode.key === "8-81") setSelectedNodeFidji("4.03. Contrats & assurances");//vérifier
          else if (foundNode.key === "8-82") setSelectedNodeFidji("4.03. Contrats & assurances");//vérifier
          else if (foundNode.key === "8-83") setSelectedNodeFidji("4.03. Contrats & assurances");//vérifier
          else if (foundNode.key === "8-84") setSelectedNodeFidji("4.05. Réception de travaux");
          else if (foundNode.key === "8-85") setSelectedNodeFidji("4.05. Réception de travaux");
          else if (foundNode.key === "8-86") setSelectedNodeFidji("4.03. Contrats & assurances");//vérifier
          else if (foundNode.key === "8-87") setSelectedNodeFidji("4.05. Réception de travaux");
  
          else if (foundNode.key === "9-90-1-10-11") setSelectedNodeFidji("Diagnostics amiante");
          else if (foundNode.key === "9-90-1-10-12") setSelectedNodeFidji("Diagnostics amiante");
          else if (foundNode.key === "9-90-1-10-13") setSelectedNodeFidji("Diagnostics amiante");
          else if (foundNode.key === "9-90-2") setSelectedNodeFidji("DPE");
          else if (foundNode.key === "9-90-3") setSelectedNodeFidji("Diagnostics plomb");
          else if (foundNode.key === "9-91") setSelectedNodeFidji("08.01.05. PV de sécurité incendie et accessibilité");//vérifier
          else if (foundNode.key === "9-92") setSelectedNodeFidji("08.01.05. PV de sécurité incendie et accessibilité");//vérifier
          else if (foundNode.key === "9-93") setSelectedNodeFidji("08.01.02. Audit environnemental +");//vérifier
  
          else if (foundNode.key === "10-100") setSelectedNodeFidji("05.01. Plans");

        else if (foundNode.key === "11-110") setSelectedNodeFidji("05.03. Copropriété & gouvernance de voisinage");

        else if (foundNode.key === "12-120") setSelectedNodeFidji("05.03. Copropriété & gouvernance de voisinage");
        
        }
      }
    }
  };

  const findNodeKeyByLabel = (nodes, label) => {
    for (const node of nodes) {
      if (node.label === label) {
        return node.key;
      }
      if (node.children) {
        const key = findNodeKeyByLabel(node.children, label);
        if (key !== undefined) {
          return key;
        }
      }
    }
    return undefined;
  };

  

  useEffect(() => {
    if (selectedClasseur) {
      Object.keys(selectedClasseur).forEach((key) => {
        setValue(key, selectedClasseur[key]);
      });
      setSelectedNode(selectedClasseur.typologie_gexpertise);
      setSelectedNodeFidji(selectedClasseur.typologie_fidji);
    }
    const selectedNodeKey = findNodeKeyByLabel(
      NODES_CLASSEUR_EDIT,
      selectedClasseur.typologie_gexpertise
    );

    if (selectedNodeKey) {
      setSelectedKey(selectedNodeKey);
    }
  }, [selectedClasseur, setValue]);

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const classeurData = {
        nom_classeur: data.nom_classeur,
        projet_classeur: data.projet_classeur,
        typologie_gexpertise: selectedNode,
        typologie_fidji: selectedNodeFidji,
      };

      await classeursService
        .update(selectedClasseur.id, classeurData)
        .then(() => {
          setLoading(false);
          showToast("success", "classeur modifié avec succès");
          queryClient.refetchQueries({
            queryKey: ["classeurs"],
          });
          setSelectedKey(null);
          setSelectedNode(null);
          setSelectedNodeFidji("");
        });
      closeModalEdit();
    } catch (e) {
      setLoading(true);
      console.log("Error while fetching", e);
    }
  };
  return (
    <>
      <CustomDialog
        header="Modifier classeur"
        visible={modalIsOpenEdit}
        closeModalDialog={() => {
          closeModalEdit();
          reset();
        }}
      >
        <div className="w-full h-full ">
          <div className="p-6 space-y-6">
            <TabMenu
              model={items}
              activeIndex={activeIndex}
              className="flex justify-center "
              onTabChange={(e) => setActiveIndex(e.index)}
            />
            {activeIndex === 0 ? (
              <form
                onSubmit={handleSubmit(onSubmit)}
                encType="multipart/form-data"
              >
                <div className="grid grid-cols-6 gap-6 mb-2">
                  <div className="col-span-6 sm:col-span-6">
                    <label
                      htmlFor="nom_classeur"
                      className="block text-md font-bold leading-6 text-gray-900"
                    >
                      Nom *
                    </label>
                    <input
                      type="text"
                      id="nom_classeur"
                      name="nom_classeur"
                      placeholder="Saisir nom classeur"
                      className="  my-3 border border-gray-300 text-gray-900 font-normal text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                      {...register("nom_classeur", {
                        required: true,
                      })}
                    />
                    {errors.nom_classeur && (
                      <span className="bg-red-100 text-red-800 text-sm font-medium mr-2 mt-2  px-2 py-1 rounded ">
                        champs obligatoire
                      </span>
                    )}
                  </div>
                

                  <div className="col-span-6 sm:col-span-6">
                    <label className="block text-md font-bold leading-6 text-gray-900 mb-2">
                      Type
                    </label>

                    <Tree
                      value={NODES_CLASSEUR_EDIT}
                      selectionMode="single"
                      selectionKeys={selectedKey}
                      onSelectionChange={(e) => onSelectionChange(e)}
                      className="w-full md:w-30rem"
                      nodeTemplate={nodeTemplate}
                      togglerTemplate={togglerTemplate}
                    />
                  </div>
                  <p className=" text-lg font-thin my-4">* obligatoire</p>
                </div>
                <div className="flex justify-end space-x-2 mt-10">
                  <button
                    type="submit"
                    className="text-white   bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-md px-6 py-3  text-center "
                  >
                    modifier
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      closeModalEdit();
                      reset();
                    }}
                    className="text-gray-600 border border-gray-600 bg-white hover:bg-gray-100 font-medium rounded-lg text-sm px-6 py-2  text-center "
                  >
                    Annuler
                  </button>
                </div>
              </form>
            ) : (
              <FormEditCorrespondanceClasseur
                actif={actifs}
                selectedClasseur={selectedClasseur}
                closeModalEdit={closeModalEdit}
                setLoading={setLoading}
                
              />
            )}
          </div>
        </div>
      </CustomDialog>
    </>
  );
};

export default ModalEditClasseur;
